// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IHeader
 */
export interface IHeader {
    /**
     * Setting this value will assign OCS user id for internal ODS Calls for auditing.
     * @type {string}
     * @memberof IHeader
     */
    user?: string | null;
    /**
     * Agent, copyBookList = [{copybook:"CCNDPUBS", fields:[{name:"'PMXDS'-RI-ACCT-LVL-3", length:"4", eventTypes:[""]}]}, {copybook:"CCTOKNWS", fields:[{name:"'XXX'-AGENT-NR", length:"4", eventTypes:["TOKEN"]}]}, {copybook:"MCATDSHB", fields:[{name:"&T.AGENT", length:"4", eventTypes:["TRAN"]}]}, {copybook:"MCPIPDAT", fields:[{name:"&T.AGENT", length:"4", eventTypes:["TRAN"]}]}, {copybook:"FRFALLOG", fields:[{name:"FFSL-AGENT-NUM", length:"4", eventTypes:["FRFAD"]}]}], eventTypeList:["ALL"]
     * @type {string}
     * @memberof IHeader
     */
    agent?: string | null;
    /**
     * Setting this value will assign cycle destination for backend system, copyBookList = [{copybook:"MCATDSHB", fields:[{name:"&T.CYCLE", length:"1", eventTypes:["TRAN"]}]}, {copybook:"MCPIPDAT", fields:[{name:"&T.CENTER", length:"1", eventTypes:["TRAN"]}]}], eventTypeList:["TRAN"]
     * @type {string}
     * @memberof IHeader
     */
    cycle?: string | null;
    /**
     * Client Number, copyBookList = [{copybook:"CCNDPUBS", fields:[{name:"'PMXDS'-RI-CLIENT-ID", length:"4", eventTypes:[""]}]}, {copybook:"CCTOKNWS", fields:[{name:"'XXX'-CLIENT-NR", length:"4", eventTypes:["TOKEN"]}]}, {copybook:"MCATDSHB", fields:[{name:"&T.CLIENT", length:"4", eventTypes:["TRAN"]}]}, {copybook:"MCPIPDAT", fields:[{name:"&T.CLIENT", length:"4", eventTypes:["TRAN"]}]}, {copybook:"FRFALLOG", fields:[{name:"FFSL-CLIENT-NUMBER", length:"5", eventTypes:["FRFAD"]}]}], eventTypeList:["ALL"]
     * @type {string}
     * @memberof IHeader
     */
    client_number?: string | null;
    /**
     * A client often has more than one Billing System/Prin.  A client uses Billing System/Prins to segregate their expenses on their General Ledger for accounting purposes.System, copyBookList = [{copybook:"CCNDPUBS", fields:[{name:"'PMXDS'-RI-ACCT-LVL-1", length:"4", eventTypes:[""]}]}, {copybook:"CCTOKNWS", fields:[{name:"'XXX'-SYSTEM-NR", length:"4", eventTypes:["TOKEN"]}]}, {copybook:"MCATDSHB", fields:[{name:"&T.SYS", length:"4", eventTypes:["TRAN"]}]}, {copybook:"MCPIPDAT", fields:[{name:"&T.SYS", length:"4", eventTypes:["TRAN"]}]}, {copybook:"FRFALLOG", fields:[{name:"FFSL-SYSTEM-NUM", length:"4", eventTypes:["FRFAD"]}]}], eventTypeList:["ALL"]
     * @type {string}
     * @memberof IHeader
     */
    system?: string | null;
    /**
     * A client often has more than one Billing System/Prin.  A client uses Billing System/Prins to segregate their expenses on their General Ledger for accounting purposes.Principal, copyBookList = [{copybook:"CCNDPUBS", fields:[{name:"'PMXDS'-RI-ACCT-LVL-2", length:"4", eventTypes:[""]}]}, {copybook:"CCTOKNWS", fields:[{name:"'XXX'-PRIN-NR", length:"4", eventTypes:["TOKEN"]}]}, {copybook:"MCATDSHB", fields:[{name:"&T.PRIN", length:"4", eventTypes:["TRAN"]}]}, {copybook:"MCPIPDAT", fields:[{name:"&T.PRIN", length:"4", eventTypes:["TRAN"]}]}, {copybook:"FRFALLOG", fields:[{name:"FFSL-PRIN-NUM", length:"4", eventTypes:["FRFAD"]}]}], eventTypeList:["ALL"]
     * @type {string}
     * @memberof IHeader
     */
    prin?: string | null;
    /**
     * Setting this value to false will disable additional error details from backend calls.
     * @type {boolean}
     * @memberof IHeader
     */
    debug?: boolean | null;
    /**
     * Setting this value will assign to the organization identifier.
     * @type {string}
     * @memberof IHeader
     */
    org?: string | null;
    /**
     * Setting this value to true will return processor information on the response. Defaults to false
     * @type {boolean}
     * @memberof IHeader
     */
    processor?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof IHeader
     */
    content_type?: string | null;
    /**
     * Transactions on the Fiserv system that do not complete within the "timeout" interval can be retried the number of times specified in this parameter.The default value is "0", meaning a transaction will not be retried. If an application calling the API does not wish to have the Fiserv system retry the transaction, they must specify a "0" in this parameter.
     * @type {number}
     * @memberof IHeader
     */
    retry?: number | null;
    /**
     * This parameter dictates the duration by which the REST layer will wait for a transaction to complete before attempting a retry. The default value for this parameter is 45000 milliseconds.
     * @type {number}
     * @memberof IHeader
     */
    timeout?: number | null;
    /**
     * This field will be used by the service to determine the First Track, First Dispute, Fraud Detection Work Center destination. Site Id will be provided by these applications to the calling applications 
     * @type {string}
     * @memberof IHeader
     */
    site_id?: string | null;
    /**
     * Flag to indicate whether it is an event originated internally
     * @type {boolean}
     * @memberof IHeader
     */
    internal_origin?: boolean | null;
    /**
     * UUID. Universally Unique Identifier. A client-defined, client-supplied value thatthe client may use to uniquely identify a specific API request they have made. Can be used to identifyretries of the same request to complete fulfillment.
     * @type {string}
     * @memberof IHeader
     */
    uuid?: string | null;
}

/**
 * Check if a given object implements the IHeader interface.
 */
export function instanceOfIHeader(value: object): value is IHeader {
    return true;
}

export function IHeaderFromJSON(json: any): IHeader {
    return IHeaderFromJSONTyped(json, false);
}

export function IHeaderFromJSONTyped(json: any, ignoreDiscriminator: boolean): IHeader {
    if (json == null) {
        return json;
    }
    return {
        
        'user': json['user'] == null ? undefined : json['user'],
        'agent': json['agent'] == null ? undefined : json['agent'],
        'cycle': json['cycle'] == null ? undefined : json['cycle'],
        'client_number': json['clientNumber'] == null ? undefined : json['clientNumber'],
        'system': json['system'] == null ? undefined : json['system'],
        'prin': json['prin'] == null ? undefined : json['prin'],
        'debug': json['debug'] == null ? undefined : json['debug'],
        'org': json['org'] == null ? undefined : json['org'],
        'processor': json['processor'] == null ? undefined : json['processor'],
        'content_type': json['contentType'] == null ? undefined : json['contentType'],
        'retry': json['retry'] == null ? undefined : json['retry'],
        'timeout': json['timeout'] == null ? undefined : json['timeout'],
        'site_id': json['siteId'] == null ? undefined : json['siteId'],
        'internal_origin': json['internalOrigin'] == null ? undefined : json['internalOrigin'],
        'uuid': json['uuid'] == null ? undefined : json['uuid'],
    };
}

export function IHeaderToJSON(json: any): IHeader {
    return IHeaderToJSONTyped(json, false);
}

export function IHeaderToJSONTyped(value?: IHeader | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'user': value['user'],
        'agent': value['agent'],
        'cycle': value['cycle'],
        'clientNumber': value['client_number'],
        'system': value['system'],
        'prin': value['prin'],
        'debug': value['debug'],
        'org': value['org'],
        'processor': value['processor'],
        'contentType': value['content_type'],
        'retry': value['retry'],
        'timeout': value['timeout'],
        'siteId': value['site_id'],
        'internalOrigin': value['internal_origin'],
        'uuid': value['uuid'],
    };
}

